var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 1.83301H13.0167C10.0833 1.83301 8.25 3.66634 8.25 6.59967V10.3122H13.9792C14.355 10.3122 14.6667 10.6238 14.6667 10.9997C14.6667 11.3755 14.355 11.6872 13.9792 11.6872H8.25V15.3997C8.25 18.333 10.0833 20.1663 13.0167 20.1663H15.3908C18.3242 20.1663 20.1575 18.333 20.1575 15.3997V6.59967C20.1667 3.66634 18.3333 1.83301 15.4 1.83301Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18129 10.3126L6.07879 8.41518C6.21629 8.27768 6.28046 8.10352 6.28046 7.92935C6.28046 7.75518 6.21629 7.57185 6.07879 7.44352C5.81296 7.17768 5.37296 7.17768 5.10712 7.44352L2.03629 10.5143C1.77046 10.7801 1.77046 11.2201 2.03629 11.486L5.10712 14.5568C5.37296 14.8226 5.81296 14.8226 6.07879 14.5568C6.34462 14.291 6.34462 13.851 6.07879 13.5851L4.18129 11.6876H8.25129V10.3126H4.18129Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.299b67834b620ab99772c7b85e78549a.svg";
export { ForwardRef as ReactComponent };